<div
  class="card"
  layout-horizontal
  layout-align-items-center
  padding-medium
  [class.rt-card-background-light]="hasIntegration"
>
  <div class="icon-box" layout-align-self-start>
    <ng-content select="[icon]"></ng-content>
  </div>

  <div layout layout-align-items-center layout-space-between layout-full-width>
    <div margin-lr-medium>
      <rt-heading>
        {{ heading }}
        <rt-badge
          *ngIf="teamIntegrationsCount > 0"
          [rtTooltip]="
            'app.settings.integrations.x_members_integrated'
              | translate: { name: heading, count: teamIntegrationsCount }
          "
          color="counter-default"
          [text]="teamIntegrationsCount"
          margin-left-small-x
        >
        </rt-badge>
        <rt-badge
          margin-left-small-x
          color="success"
          [text]="'app.settings.integrations.integrated' | translate"
          *ngIf="hasIntegration"
        ></rt-badge>
      </rt-heading>

      <div variant="subheading">
        <ng-content select="[description]"></ng-content>
      </div>
    </div>

    <div *ngIf="!isComingSoon && isIntegrationLoaded">
      <rt-group variant="horizontal">
        <div *ngIf="!hasIntegration">
          <rt-button (click)="integrate.emit()" variant="outlined">
            {{ 'app.settings.integrations.integrate_now' | translate }}
          </rt-button>
        </div>

        <div *ngIf="hasIntegration">
          <rt-button
            #integrationActionsDropdownTrigger="rtOverlayOrigin"
            [loading]="isRemoving"
            (click)="toggleDropdown(!state.dropdownOpen)"
            rt-overlay-origin
            variant="plain"
          >
            <rt-icon name="edit"></rt-icon>
            {{ 'app.settings.integrations.manage' | translate }}
          </rt-button>
          <ng-template
            #integrationActionsDropdown="rtConnectedOverlay"
            rt-connected-overlay
            hasBackdrop
            [origin]="integrationActionsDropdownTrigger"
            [open]="state.dropdownOpen"
            (backdropClick)="toggleDropdown(false)"
          >
            <rt-dropdown [width]="DropdownWidth.SmallX">
              <div class="integration__dropdown-items" (click)="toggleDropdown(false)">
                <ng-content select="[dropdown-items]"></ng-content>
              </div>

              <rt-dropdown-item *ngIf="hasRole" routerLink="/settings/roles">
                {{ 'app.settings.integrations.manage_roles' | translate }}
              </rt-dropdown-item>
              <rt-dropdown-item (click)="confirmRemove()">
                {{ 'app.settings.integrations.disconnect' | translate }}
              </rt-dropdown-item>
            </rt-dropdown>
          </ng-template>
        </div>
      </rt-group>
    </div>

    <rt-button *ngIf="isComingSoon" variant="outlined" [disabled]="true">
      {{ 'app.settings.integrations.coming_soon' | translate }}
    </rt-button>
  </div>
</div>
